import React, { Component, PropTypes  } from 'react'
import LoginValidationForm from './LoginValidationForm'
import { browserHistory } from 'react-router'
import cookie from 'react-cookie'
import { api, domen } from '../../config.js'
import Modal from 'boron/FadeModal'
import CSSModules from 'react-css-modules'
import styles from './loginValidationForm.css'
let contentStyle = {
  borderRadius: '18px',
  fontSize: '22px',
  padding: '30px'
}
const modalStyle={
  maxWidth: '500px',
  width: '90%'
}
class LoginValidationFormWrapper extends Component {
  render(){
    const { setToken, smm, setAuth, setSimpleRegs, setUserProfile, errorModal, loadingModal } = this.props
    const isAlfa = domen.isAlfa
    let isUnipro = domen.isUnipro
    let isTele2Lk = domen.isTele2
    return(
      <div className={smm ? styles.wrapper : null}>
        <LoginValidationForm smm={smm} onSubmit={ data => {
          loadingModal.show()
          return fetch(`${api}/user/authenticate`, {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(data)
          })
            .then(response => response.json())
            .then(json => {
              loadingModal.hide()
              if(json.data && json.errorCode === 1 && json.data.role === 4){
                cookie.save('token', json.data.authToken, {path: '/', maxAge: 60 * 60 * 24 * 365 * 10})
                const data = {
                  firstName: json.data.firstName,
                  lastName:json.data.lastName,
                  program:json.data.program,
                  photo:json.data.photo,
                  gender:json.data.gender,
                  role:json.data.role
                }
                setAuth(true)
                setSimpleRegs(true)
                setUserProfile(data)
                return;
              }
              if (json.data && json.errorCode === 1 && json.data.paidState !== 0) {
                window.carrotquest.auth(json.data.id, json.data.cqhmac)
                cookie.save('token', json.data.authToken, {path: '/', maxAge: 60 * 60 * 24 * 365 * 10})
                setToken(json.data.authToken)
                setAuth(true)
                cookie.save('userProgram', json.data.program, {path: '/', maxAge: 60 * 60 * 24 * 365 * 10})
                cookie.save('fullName', json.data.firstName + ' ' + json.data.lastName, {
                  path: '/',
                  maxAge: 60 * 60 * 24 * 365 * 10
                })

                if (json.data.paidState === 2) {
                  browserHistory.push('/signup/pay/success')
                }  else if (!json.data.emailConfirmed){
                  browserHistory.push('/confirme')
                } else if (json.data.paidState === -1) {
                  browserHistory.push('/signup/params')
                } else if (json.data.isFirstEdit) {
                  browserHistory.push('/profile')
                } else {
                  //browserHistory.push('/task')
                  //browserHistory.push('/signup/pay/success')
                }
              } else if (json.data && json.data.paidState !== 0 && (json.data.program === 12 || json.data.program === 16)) {
                window.carrotquest.auth(json.data.id, json.data.cqhmac)
                cookie.save('token', json.data.authToken, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
                browserHistory.push('/signup/pay/friend?simple=true')
                setAuth(true)
              } else if (json.data && !json.data.program) {
                window.carrotquest.auth(json.data.id, json.data.cqhmac)
                cookie.save('token', json.data.authToken, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
                //browserHistory.push('/signup/pay/success')
                browserHistory.push('/')
                setAuth(true)
                //browserHistory.push('/profile')
              } else if (json.data && (!isAlfa && (json.data.paidState === 0 || json.data.paidState === 1))) {
                window.carrotquest.auth(json.data.id, json.data.cqhmac)
                cookie.save('token', json.data.authToken, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
                //browserHistory.push('/signup/pay')
                setAuth(true)
                browserHistory.push('/')
              } else if (json.data && (isAlfa || isTele2Lk || isUnipro) && json.data.paidState === 0){
                cookie.save('token', json.data.authToken, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
                //browserHistory.push('/signup/pay/success')
                setAuth(true)
                browserHistory.push('/')
              } else if (json.data && (isAlfa || isTele2Lk || isUnipro) && json.data.paidState === 1){
                browserHistory.push('/task')
                setAuth(true)
                //browserHistory.push('/signup/pay/success')
              } else {
               errorModal.show()
              }
            })
        }}/>
      </div>
    )
  }
}

export default CSSModules(LoginValidationFormWrapper, styles)


// WEBPACK FOOTER //
// /var/www/build-health-2/src/components/profile/LoginValidationFormWrapper.js